//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ClassFunc = require('../../../util/ClassFunc')
const Stats = require('./Stats')

/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_icehockey_PlayerStatsGame = function() {
    // console.log('tbs_model_vo_icehockey_PlayerStatsGame constructor')
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Stats, arguments)
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_icehockey_PlayerStatsGame.prototype = {
    /* The view object name */
    name: 'game',
    /* The view object instance */
    view: {
        get: [
            {
                name: 'seasons',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/seasons/option',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                },
                basePath: '',
                rule: {
                    text: '~season',
                    value: '~season',
                }
            },
            {
                name: 'leagues',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/leagues/option',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                    season: 'season',
                },
                basePath: '',
                rule: {
                    text: 'leagueName',
                    value: '~leagueId',
                }
            },
            {
                name: 'groups',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/groups/option',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                    season: 'season',
                    league: 'league',
                },
                basePath: '',
                rule: {
                    text: 'groupName',
                    value: '~groupId',
                }
            },
            {
                name: 'games',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/games/:role/2',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                    role: 'role',
                    season: 'season',
                    league: 'league',
                    group: 'group'
                },
                basePath: '',
                rule: {
                    gameId: 'gameId',
                    shortDate: '$gameDate',
                    leagueId: 'leagueId',
                    league: 'leagueName',
                    season: 'season',
                    groupId: 'groupId',
                    group: 'groupName',
                    team: 'clubTeamName',
                    opp: 'oppClubTeamName',
                    score: '$score,oppScore',
                    position: '$position',
                    g: 'g',
                    a: 'a',
                    p: 'p',
                    pim: 'pim',
                    ppg: 'ppg',
                    shg: 'shg',
                    psg: 'psg',
                    otg: 'otg',
                    gwg: 'gwg',
                    sos: 'sos',
                    sog: 'sog',
                    ga: 'ga',
                    ppga: 'ppga',
                    shga: 'shga',
                    psga: 'psga',
                    otga: 'otga',
                    gwga: 'gwga',
                    sosa: 'sosa',
                    soga: 'soga',
                    sosv: 'sosv',
                    sosvp: '$sosvp',
                }
            }
        ],
        map: {
            baseUrl: process.env.VUE_APP_HOCKEY_API,
            apiPrefix: '/hockey/',
            service: 'getBMGameBySourceGameId',
            query: {
                sourceGameId: 'gameId',
            },
            basePath: 'data',
            rule: {
                gameId: 'gameId',
                matchId: 'matchId'
            }
        },
    },
}

//--------------------------------------------------
// extends the Stats
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_icehockey_PlayerStatsGame, Stats)

module.exports = tbs_model_vo_icehockey_PlayerStatsGame